import { useState, useRef, useEffect } from 'react';
import { Client } from '@umanforge/common';
import ClientSelector from './clientSelector.component';
import Bar from '../bar.component';

interface TopBarProps {
  clients: Client[];
  onChange: ( clientIndex: number ) => void;
  selectedClientId?: string;
}

function TopBar( { clients, onChange, selectedClientId }: TopBarProps ) {
  const initialSelected =
    ( selectedClientId && clients.find( c => {return c.id === selectedClientId;} ) ) ||
    clients[ 0 ] ||
    null;
  const [ selectedClient, setSelectedClient ] = useState<Client | null>( initialSelected );
  const [ remainingClients, setRemainingClients ] = useState<Client[]>(
    initialSelected ? clients.filter( c => {return c.id !== initialSelected.id;} ) : clients.slice( 1 )
  );
  const [ isPopupVisible, setIsPopupVisible ] = useState( false );

  const popupRef = useRef<HTMLSpanElement | null>( null );
  const buttonRef = useRef<HTMLButtonElement | null>( null );

  const togglePopup = () => {
    if ( clients.length > 1 ) {setIsPopupVisible( prev => {return !prev;} );}
  };

  const handleClientClick = ( client: Client ) => {
    const updatedClients = [ ...remainingClients, selectedClient! ];
    const filteredClients = updatedClients.filter( c => {return c.id !== client.id;} );
    setSelectedClient( client );
    setRemainingClients( filteredClients );
    setIsPopupVisible( false );

    const index = clients.findIndex( c => {return c.id === client.id;} );
    if ( index !== -1 ) {onChange( index );}
  };

  useEffect( () => {
    const handleClickOutside = ( e: MouseEvent ) => {
      if (
        popupRef.current &&
        !popupRef.current.contains( e.target as Node ) &&
        buttonRef.current &&
        !buttonRef.current.contains( e.target as Node )
      ) {
        setIsPopupVisible( false );
      }
    };

    document.addEventListener( 'mousedown', handleClickOutside );
    return () => {return document.removeEventListener( 'mousedown', handleClickOutside );};
  }, [] );

  useEffect( () => {
    const newSelected =
      ( selectedClientId && clients.find( c => {return c.id === selectedClientId;} ) ) ||
      clients[ 0 ] ||
      null;
    setSelectedClient( newSelected );
    setRemainingClients( newSelected ? clients.filter( c => {return c.id !== newSelected.id;} ) : clients.slice( 1 ) );
  }, [ clients, selectedClientId ] );

  return (
    <div className="flex-center py-3">
      <div className="flex items-center w-full">
        {selectedClient ? (
          <ClientSelector
            selected={selectedClient}
            otherClients={remainingClients}
            toggle={togglePopup}
            showPopup={isPopupVisible}
            onClientClick={handleClientClick}
            popupRef={popupRef}
            buttonRef={buttonRef}
            isClickable={clients.length > 1}
          />
        ) : (
          <span className="font-comfortaa text-3xl mr-4">&nbsp;</span>
        )}
        <Bar />
      </div>
    </div>
  );
}

export default TopBar;
